<template>
    <div :class="'md-layout-item item no-padding '+ mdSize1 ">
      <div class="md-layout">
        <div :class="'md-layout-item item no-padding '+ mdSize2 ">
          <div class="margin-item-name">
            {{name}}
              <i v-if="name == 'Cto. de cultivo (USD/ha)'" class="fa fa-info-circle" aria-hidden="true"></i>
              <md-tooltip v-if="name == 'Cto. de cultivo (USD/ha)'" md-direction="top" class="info-tooltip">Costo total, incluye cosecha, <br>no incluye alquiler ni gastos <br>de comercialización</md-tooltip>
          </div>
        </div>
        <div :class="'md-layout-item item pad-right-5 '+ mdSize3 ">
          <md-button class="md-info md-sm" @click="clickUp1"><strong>+</strong></md-button>
          <input type="text" class="md-input" v-model="val1" @keydown.enter="keyDown1">
          <md-button class="md-info md-sm" @click="clickDown1"><strong>-</strong></md-button>
          <br>
          <md-button v-if="data.doble" class="md-info md-sm" @click="clickUp2"><strong>+</strong></md-button>
          <input v-if="data.doble" type="text" class="md-input" v-model="val2" @keydown.enter="keyDown2">
          <md-button v-if="data.doble" class="md-info md-sm" @click="clickDown2"><strong>-</strong></md-button>
        </div>
        <div v-if="info" class="md-layout-item item no-padding md-size-25">
          <div class="margin-item-name">{{info.name}}</div>
        </div>
        <div v-if="info" class="md-layout-item item no-padding md-size-20">
          <div class="margin-item-info-value">{{info.value1}}</div></span>
          <div v-if="data.doble" class="margin-item-info-value">{{info.value2}}</div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'margin-item',
  props: ['name','data', 'type'],
  data() {
    return {
      val1: this.data.value1,
      val2: this.data.value2,
      info: this.data.info
    }
  },
  computed: {
    mdSize1() {
      return (!this.data.info) ? 'md-size-15' : 'md-size-22';
    },
    mdSize2() {
      return (!this.data.info) ? 'md-size-20' : 'md-size-15';
    },
    mdSize3() {
      return (!this.data.info) ? 'md-size-80' : 'md-size-40';
    }
  },
  methods: {
    isFloat(n){
      return Number(n) === n && n % 1 !== 0;
    },
    clickUp1() {
      this.val1++;
      if (this.isFloat(this.val1))
        this.val1 = parseFloat(this.val1).toFixed(1);
      this.$emit('update-value1', this.val1, this.type);
    },
    clickDown1() {
      this.val1--;
      if (this.isFloat(this.val1))
        this.val1 = parseFloat(this.val1).toFixed(1);
      this.$emit('update-value1', this.val1, this.type);
    },
    clickUp2() {
      this.val2++;
      if (this.isFloat(this.val2))
        this.val1 = parseFloat(this.val2).toFixed(1);
      this.$emit('update-value2', this.val2, this.type);
    },
    clickDown2() {
      this.val2--;
      if (this.isFloat(this.val2))
        this.val1 = parseFloat(this.val2).toFixed(1);
      this.$emit('update-value2', this.val2, this.type);
    },
    keyDown1() {
      this.$emit('update-value1', this.val1, this.type);
    },
     keyDown2() {
      this.$emit('update-value2', this.val2, this.type);
    }
  }
}
</script>
<style>


#margins-menu .item{
  text-align: right;
}
#margins-menu .md-button{
  min-width: 25px;
}
#margins-menu span{
  font-weight: bold;
  line-height: 35px;
  margin-right:3px;
  font-size: 12px;
}
#margins-menu .md-ripple{
  padding: 5px !important;
}
#margins-menu .md-input{
  width: 40px;
  height: 25px;
  font-size: 14px;
  margin-top:5px;
  text-align: center;
}
.info-tooltip {
  font-size: 11px;
  line-height: 1.1em;
}
.pad-right-5{
  padding-right: 5px !important;
}
.margin-item-name{
  font-size: 12px;
  line-height: 1.2em;
  font-weight:bold;
  text-align: left;
  margin-top:4px;
}

.no-padding{
    padding-right: 0;
    padding-left: 0;
}
.margin-item-info-value{
  font-size:14px;
  text-align: center;
  border: 1px solid #ddd;
  margin-right:5px;
  padding: 1px;
  font-weight: bold;
  margin-top: 4px;
}
</style>
